import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let AllProjectsThunk = createAsyncThunk(
	"Projects/AllProjectsThunk",
	async (arg, ThunkApi) => {
		console.log(arg?.page);
		let { rejectWithValue } = ThunkApi;
		try {
			let url = `api/admin/projects?page=${arg.page}&per_page=10`;

			let res = await axios.get(url);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
